import React, { useState, useEffect } from 'react'
import { SearchBox, tag2criteria } from '@/pages/ProfessionPage/SearchBox/index'
// import { OverViewType } from "../../../../ProfessionPage/OverViewPage/OverViewType/index"
import { useAppDispatch, useAppSelector } from '@/hooks'
import { getCompareWorkListByTags, getImagesOfWorkRequest, SRC_URL } from '@/server'
import './index.less'
import * as d3 from 'd3'
import {
  setCompareList,
  setCompareTotal,
  setNowComparePage
} from '@/features/SetCompareTypeList/setCompareTypeList'
import {
  setCompareImageId,
  setCompareWorkId
} from '@/features/SetCompareImageInfo/setCompareImageInfo'
import { SelectWorkList } from '@/components/SelectWorkList'
import { setShowType } from '@/features/SetCompareInfo/setCompareInfo'
import { setToken } from '@/features/Login/login'
import { useNavigate } from 'react-router-dom'

export default function SearchPanel() {
  const navigate = useNavigate()
  const token = useAppSelector((state) => state.login.token)
  //画作列表
  const searchResultList = useAppSelector((state) => state.compareTypeList.compareList)
  const paintingNum = useAppSelector((state) => state.compareTypeList.total)
  // 缓存的tagsList和keyword
  const tagsList = useAppSelector((state) => state.compareTagsList.tagsList)
  const keyword = useAppSelector((state) => state.compareTagsList.keyword)
  const dispatch = useAppDispatch()
  // 总页数
  const [pageTotal, setPageTotal] = useState<number>(1)
  // 一页的容量
  const size = 6
  // 画作当前展示的页数
  const nowPage = useAppSelector((state) => state.compareTypeList.nowComparePage)
  const [pageState, setPageState] = useState<any>([])
  // 待选列表
  const [showWorkList, setShowWorkList] = useState<{ id: string; imageId: string; src: string }[]>(
    []
  )
  // 每张图的三角形icon是否展示
  const [iconArr, setIconArr] = useState<boolean[]>(Array(8).fill(false))
  useEffect(() => {
    setPageTotal(Math.ceil(paintingNum / size))
  }, [paintingNum])
  // 切换页面
  const handleChangePage = function (index: number) {
    if (index < 1 || index > pageTotal) return
    dispatch(setNowComparePage(index))
    // 请求数据
    // 整理数据
    const dataObj: {
      keyword: string
      criteria: { key: string; value: string[] }[]
      pages: { page: number; size: number }
    } = {
      keyword: keyword,
      criteria: [],
      pages: {
        page: index,
        size: size
      }
    }
    for (const key in tagsList) {
      if (tagsList[key].length > 0) {
        dataObj.criteria.push({ key: tag2criteria[key], value: tagsList[key] })
      }
    }
    //发起请求
    getCompareWorkListByTags(token, dataObj).then((res) => {
      if (res.data.code === '10056') {
        //token失效
        window.confirm('登录已过期，请重新登录！')
        dispatch(setToken(''))
        navigate('/')
      } else {
        const list = res.data.content.list.map((item) => {
          return {
            workId: item.workid,
            workName: item.workname,
            museum: item.instname,
            mediaType: item.mediatype,
            materialType: item.materialtype,
            styleType: item.styletype,
            horizontal: item.horizontal,
            vertical: item.vertical,
            authorName: item.authorname,
            dynasty: item.dynasty,
            class1: item.class1,
            class2: item.class2,
            src: item.encoding,
            tilesPath: item.tilesPath
          }
        })
        dispatch(setCompareTotal(res.data.content.total))
        dispatch(setCompareList(list))
      }
    })
  }
  // 点击画作的回调
  const handleClickItem = function (id: string, index: number) {
    getImagesOfWorkRequest({ workId: id }, token).then((res) => {
      const list = res.data.content.map((work) => {
        return {
          id,
          imageId: work.imageid,
          src: work.fullpath
        }
      })
      if (list.length === 1) {
        dispatch(setCompareWorkId(id))
        dispatch(setCompareImageId(list[0].imageId))
        dispatch(setShowType(2))
      } else {
        setShowWorkList(list)
        //三角形标志的显隐
        setIconArr(
          iconArr.map((_icon, i) => {
            if (i === index) return true
            else return false
          })
        )
        //待选列表的位置设置
        const selectWorkListDiv = d3.select('#select-work-list')
        const itemHeight = d3.select('.list-item')._groups[0][0].clientHeight
        if (index < 2) selectWorkListDiv.style('top', itemHeight + itemHeight / 3 + 'px')
        else if (index < 4) selectWorkListDiv.style('top', 3 * itemHeight - itemHeight / 2 + 'px')
        else selectWorkListDiv.style('top', itemHeight + (1.2 * itemHeight) / 3 + 'px')
      }
    })
  }
  //分页
  useEffect(() => {
    // 阈值
    if (pageTotal < 10) {
      setPageState(
        Array(pageTotal)
          .fill(0)
          .map((_item, i) => i + 1)
      )
    } else {
      if (nowPage <= 3) {
        setPageState([1, 2, 3, 4, 'R', pageTotal])
      } else if (nowPage >= pageTotal - 2) {
        setPageState([1, 'L', pageTotal - 3, pageTotal - 2, pageTotal - 1, pageTotal])
      } else {
        setPageState([1, 'L', nowPage - 1, nowPage, nowPage + 1, 'R', pageTotal])
      }
    }
  }, [pageTotal, nowPage])
  //点击待选列表外部，清除待选列表
  useEffect(() => {
    const func = (e: any) => {
      const selectWorkListDiv = document.querySelector('#select-work-list')
      if (selectWorkListDiv && !selectWorkListDiv.contains(e.target)) {
        d3.select('#select-work-list').style('display', 'none')
        setShowWorkList([])
        setIconArr(Array(8).fill(false))
      }
    }
    document.addEventListener('mousedown', func)
    return () => {
      document.removeEventListener('mousedown', func)
    }
  })
  return (
    <div className='comparison-page-search'>
      <div className='show-pic'>
        <div className='show-pic-list'>
          {searchResultList.map((painting, index) => {
            return (
              <div className='list-item' onClick={() => handleClickItem(painting.workId, index)}>
                <div
                  className={`tri-icon-${index < 4 ? 'top' : 'bottom'}`}
                  style={{ display: iconArr[index] ? 'block' : 'none' }}
                ></div>

                <img src={painting.src ? SRC_URL + painting.src : ''} alt='' />
                <div className='item-desc'>
                  <div className='item-name'>{painting.workName}</div>
                  <div className='item-info'>
                    {painting.dynasty}/{painting.authorName}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        <div className='show-pic-foot'>
          <div
            className='pre-btn'
            onClick={() => handleChangePage(nowPage - 1)}
            style={{
              cursor: nowPage === 1 ? 'auto' : 'pointer',
              color: nowPage === 1 ? 'gray' : '#9b7a65',
              borderColor: nowPage === 1 ? 'gray' : '#9b7a65'
            }}
          >
            {'<'}
          </div>
          <div className='page-box'>
            {pageState.map((item, _index) => {
              if (item === 'L') {
                return (
                  <div className='ellipsis-btn' onClick={() => handleChangePage(nowPage - 3)}>
                    ···
                  </div>
                )
              } else if (item === 'R') {
                return (
                  <div className='ellipsis-btn' onClick={() => handleChangePage(nowPage + 3)}>
                    ···
                  </div>
                )
              } else {
                return (
                  <div
                    className='page-btn'
                    onClick={() => handleChangePage(item)}
                    style={{
                      cursor: nowPage === item ? 'auto' : 'pointer',
                      color: nowPage === item ? 'white' : '#9b7a65',
                      backgroundColor: nowPage === item ? '#9b7a65' : 'white'
                    }}
                  >
                    {item}
                  </div>
                )
              }
            })}
          </div>
          <div
            className='pre-btn'
            onClick={() => handleChangePage(nowPage + 1)}
            style={{
              cursor: nowPage === pageTotal ? 'auto' : 'pointer',
              color: nowPage === pageTotal ? 'gray' : '#9b7a65',
              borderColor: nowPage === pageTotal ? 'gray' : '#9b7a65'
            }}
          >
            {'>'}
          </div>
        </div>
      </div>
      <div
        className='select-work-list'
        id='select-work-list'
        style={{ display: showWorkList.length > 1 ? 'flex' : 'none' }}
      >
        <SelectWorkList showWorkList={showWorkList} listSize={2} type={2} />
      </div>
      <div className='search-pic'>
        <SearchBox pageType={1} selectedType={2} />
      </div>
    </div>
  )
}
